import {TradeType} from 'app/console-api';
import { Icon } from '@iconify/react';
import {BodyText} from '@make-software/cspr-design';
import {StyledChipsTag} from 'app/components/common/common-styles';
import {useTheme} from 'styled-components';
import {
  DealTradeTypes
} from 'app/components/common/deal-trade-type/deal-trade-type-meta';


export const DealTradeChip = ({ type }: { type: TradeType }) => {
  const tradeType = DealTradeTypes.find((dt) => dt.key === type);
  const theme = useTheme();
  if (!tradeType) return null;

  return (
    <StyledChipsTag color={theme.styleguideColors.contentSecondary} gap={4}>
      <Icon icon={tradeType.icon} width="18" height="18" />
      <BodyText size={3} scale={'xs'}>
        {tradeType.name}
      </BodyText>
    </StyledChipsTag>
  );
}